<template>
  <div
    class="w-full text-[var(--text)] gap-2 p-4 bg-[var(--fundoForm)] rounded-[10px] bg-opacity-[0.55] flex flex-col"
  >
    <div class="w-full flex justify-between items-center">
      <h3 class="text-[var(--titulo)]">Endereço:</h3>
      <div class="flex gap-2 items-center">
        <!-- Only show multiple-pins button and label if multiplePin_mode is active -->
        <div v-if="multiplePin_mode" class="flex gap-2 items-center">
          <!-- <label for="multiplePin">Modo Multiplos Pinos</label> -->

          <AppButton
            v-if="isHighlighted()"
            v-bind:visibility="true"
            :font_size="12"
            color="#038c16"
            left_icon="fa-solid fa-location-crosshairs"
            text="Minha Localização"
            emitType="select"
            @select="find_my_location_ip"
          />

          <AppButton
            v-bind:visibility="true"
            :font_size="12"
            color="#ff9b05"
            left_icon="fa-solid fa-map-location-dot"
            text="salvar Pinos"
            emitType="select"
            @select="save_multiPins"
          />
        </div>

        <!-- The following buttons only appear if NOT in multiple-pin mode -->
        <AppButton
          v-if="!multiplePin_mode"
          v-bind:visibility="true"
          :font_size="12"
          color="#038c16"
          left_icon="fa-solid fa-map-location-dot"
          text="Ir para localização"
          emitType="select"
          @select="set_address"
        />
        <AppButton
          v-if="!multiplePin_mode"
          v-bind:visibility="true"
          :font_size="12"
          color="#ad0000"
          left_icon="fa-solid fa-map-pin"
          text="Utilizar Pino"
          emitType="select"
          @select="set_pin_address"
        />
        <AppButton
          v-if="!multiplePin_mode"
          v-bind:visibility="true"
          :font_size="12"
          color="#ff9b05"
          left_icon="fa-regular fa-bookmark"
          text="OK"
          emitType="select"
          @select="save_address"
        />

        <!-- Always show the close button -->
        <AppButton
          style="color: var(--icon)"
          class="self-end text-[var(--text)]"
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="23"
          :height="23"
        />
      </div>
    </div>

    <!-- Address form section - only show in single-pin mode -->
    <div
      v-if="!multiplePin_mode"
      class="flex flex-col gap-4 rounded-[10px] bg-[var(--fundoComponente)] p-4"
    >
      <div class="flex gap-6 flex-wrap">
        <div class="flex gap-2 items-center">
          <label for="pais" class="min-w-[100px]">País:</label>
          <input
            style="background-color: var(--label)"
            type="text"
            id="pais"
            v-model="address.pais"
            placeholder="País"
            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[220px]"
          />
        </div>
        <div class="flex gap-2 items-center flex-1">
          <label for="morada" class="min-w-[100px]">Morada:</label>
          <input
            style="background-color: var(--label)"
            type="text"
            id="morada"
            v-model="address.morada"
            placeholder="Morada"
            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] flex-1"
          />
        </div>
      </div>

      <div class="flex gap-6 flex-wrap">
        <div class="flex gap-2 items-center">
          <label for="codigoPostal" class="min-w-[100px]">Código Postal:</label>
          <input
            style="background-color: var(--label)"
            type="text"
            id="codigoPostal"
            v-model="address.codigoPostal"
            placeholder="Código Postal"
            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[220px]"
          />
        </div>
        <div class="flex gap-2 items-center">
          <label for="distrito" class="min-w-[100px]">Distrito:</label>
          <select
            style="background-color: var(--label)"
            id="distrito"
            v-model="distritoSelecionado"
            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[220px]"
          >
            <option value="">Distrito</option>
            <optgroup
              v-for="(distritos, grupo) in distritosPortugal"
              :key="grupo"
              :label="grupo"
            >
              <option v-for="distrito in distritos" :key="distrito" :value="distrito">
                {{ distrito }}
              </option>
            </optgroup>
            <option value="Outro">Outro</option>
          </select>
        </div>
        <div class="flex gap-2 items-center">
          <label for="localidade" class="min-w-[100px]">Localidade:</label>
          <input
            style="background-color: var(--label)"
            type="text"
            id="localidade"
            v-model="address.localidade"
            placeholder="Localidade"
            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[220px]"
          />
        </div>
      </div>

      <div class="flex gap-6 flex-wrap">
        <div class="flex gap-2 items-center">
          <label for="concelho" class="min-w-[100px]">Concelho:</label>
          <input
            style="background-color: var(--label)"
            type="text"
            id="concelho"
            v-model="address.concelho"
            placeholder="Concelho"
            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[220px]"
          />
        </div>
        <div class="flex gap-2 items-center">
          <label for="freguesia" class="min-w-[100px]">Freguesia:</label>
          <input
            style="background-color: var(--label)"
            type="text"
            id="freguesia"
            v-model="address.freguesia"
            placeholder="Freguesia"
            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[220px]"
          />
        </div>
        <div class="flex gap-2 items-center">
          <label for="latitude" class="min-w-[100px]">Latitude:</label>
          <input
            style="background-color: var(--label)"
            type="text"
            id="latitude"
            v-model="address.latitude"
            placeholder="Latitude"
            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[220px]"
          />
        </div>
      </div>

      <div class="flex gap-6 flex-wrap">
        <div class="flex gap-2 items-center">
          <label for="longitude" class="min-w-[100px]">Longitude:</label>
          <input
            style="background-color: var(--label)"
            type="text"
            id="longitude"
            v-model="address.longitude"
            placeholder="Longitude"
            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-[220px]"
          />
        </div>
      </div>
    </div>

    <!-- Map Section -->
    <h3 class="text-[#ff9b05]">Mapa:</h3>
    <GoogleMap
      v-if="api_key"
      :api-key="api_key.toString()"
      style="width: 100%; height: 500px"
      :center="mapCenter"
      :zoom="15"
    >
      <!-- Single-Pin Marker (default mode) -->
      <Marker
        v-if="!multiplePin_mode"
        :options="{ position: mapCenter, draggable: true }"
        @dragend="updateMarkerPosition"
      />

      <!-- Multiple-Pin Markers (when multiplePin_mode = true) -->
      <Marker
        v-else
        v-for="(pin, index) in multiplePin_coordinates"
        :key="pin.id || index"
        :options="{
          position: { lat: pin.lat, lng: pin.lng },
          draggable: true,
          icon: pin.highlight
            ? 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
            : 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
        }"
        @dragend="(event) => updatePinCoords(event, index)"
      />
    </GoogleMap>
  </div>
</template>

<script>
import AppButton from "@/components/updated/button.vue";
import { toast } from "vue3-toastify";
import { GoogleMap, Marker } from "vue3-google-map";
import axios from "axios";

// Distritos de Portugal continental + ilhas dos Açores e da Madeira.
// Qualquer morada fora destes valores fica como "Outro".
const DISTRITOS_PORTUGAL = {
  "Portugal Continental": [
    "Aveiro",
    "Beja",
    "Braga",
    "Bragança",
    "Castelo Branco",
    "Coimbra",
    "Évora",
    "Faro",
    "Guarda",
    "Leiria",
    "Lisboa",
    "Portalegre",
    "Porto",
    "Santarém",
    "Setúbal",
    "Viana do Castelo",
    "Vila Real",
    "Viseu",
  ],
  Açores: [
    "Corvo",
    "Faial",
    "Flores",
    "Graciosa",
    "Pico",
    "Santa Maria",
    "São Jorge",
    "São Miguel",
    "Terceira",
  ],
  Madeira: ["Madeira", "Porto Santo"],
};

// Nomes devolvidos pelo Google Geocoding (em inglês) para distritos nossos
const ALIAS_DISTRITOS = {
  lisbon: "Lisboa",
  oporto: "Porto",
};

const normalizarDistrito = (valor) =>
  (valor || "")
    .toString()
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

// Nos Açores e na Madeira o Google devolve a região
// ("Azores"/"Madeira") no administrative_area_level_1 e nunca a ilha.
// Como cada município insular pertence a uma só ilha, deduzimos a ilha a
// partir do município. Só se aplica a estas duas regiões autónomas.
const MUNICIPIOS_ACORES = {
  "vila do porto": "Santa Maria",
  lagoa: "São Miguel",
  nordeste: "São Miguel",
  "ponta delgada": "São Miguel",
  povoacao: "São Miguel",
  "ribeira grande": "São Miguel",
  "vila franca do campo": "São Miguel",
  "angra do heroismo": "Terceira",
  "praia da vitoria": "Terceira",
  "vila da praia da vitoria": "Terceira",
  "santa cruz da graciosa": "Graciosa",
  calheta: "São Jorge",
  "calheta de sao jorge": "São Jorge",
  velas: "São Jorge",
  "lajes do pico": "Pico",
  madalena: "Pico",
  "sao roque do pico": "Pico",
  horta: "Faial",
  "lajes das flores": "Flores",
  "santa cruz das flores": "Flores",
  corvo: "Corvo",
  "vila do corvo": "Corvo",
};

const MUNICIPIOS_MADEIRA = {
  calheta: "Madeira",
  "camara de lobos": "Madeira",
  funchal: "Madeira",
  machico: "Madeira",
  "ponta do sol": "Madeira",
  "porto moniz": "Madeira",
  "ribeira brava": "Madeira",
  "santa cruz": "Madeira",
  santana: "Madeira",
  "sao vicente": "Madeira",
  "porto santo": "Porto Santo",
  "vila baleira": "Porto Santo",
};

const REGIOES_INSULARES = {
  acores: MUNICIPIOS_ACORES,
  azores: MUNICIPIOS_ACORES,
  "regiao autonoma dos acores": MUNICIPIOS_ACORES,
  "autonomous region of the azores": MUNICIPIOS_ACORES,
  madeira: MUNICIPIOS_MADEIRA,
  "regiao autonoma da madeira": MUNICIPIOS_MADEIRA,
  "autonomous region of madeira": MUNICIPIOS_MADEIRA,
};

const ilhaDaRegiaoAutonoma = (pais, codigoPais, regiao, municipios) => {
  const paisNormalizado = normalizarDistrito(pais);
  const codigoNormalizado = normalizarDistrito(codigoPais);
  const ehPortugal = paisNormalizado === "portugal" || codigoNormalizado === "pt";
  if (!ehPortugal) return null;

  const regiaoNormalizada = normalizarDistrito(regiao);
  if (!Object.prototype.hasOwnProperty.call(REGIOES_INSULARES, regiaoNormalizada))
    return null;
  const ilhasDaRegiao = REGIOES_INSULARES[regiaoNormalizada];

  for (const municipio of municipios) {
    const chave = normalizarDistrito(municipio);
    if (chave && Object.prototype.hasOwnProperty.call(ilhasDaRegiao, chave))
      return ilhasDaRegiao[chave];
  }
  return null;
};

export default {
  name: "MapComponent",
  components: {
    AppButton,
    GoogleMap,
    Marker,
  },
  props: {
    initialAddress: {
      type: Object,
      default: () => ({}),
    },
    hide_address: {
      type: Boolean,
      default: false,
    },
    multiplePin_data: {
      type: Array,
      default: () => [],
    },
    multiplePin_mode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      api_key: "",
      mapCenter: { lat: 14.92656253404226, lng: -23.508422593261713 },
      address: { ...this.initialAddress },
      auto_search: false,
      // Local copy of multiplePin_data for multi-pin mode
      multiplePin_coordinates: [],
      currentSchema: "",
      baseURL: process.env.VUE_APP_URL_BASE,
    };
  },
  computed: {
    distritosPortugal() {
      return DISTRITOS_PORTUGAL;
    },
    distritoSelecionado: {
      get() {
        const atual = normalizarDistrito(this.address.distrito);
        if (!atual) return "";
        const todosDistritos = [].concat.apply(
          [],
          Object.keys(DISTRITOS_PORTUGAL).map((g) => DISTRITOS_PORTUGAL[g])
        );
        const correspondencia = todosDistritos.find(
          (distrito) => normalizarDistrito(distrito) === atual
        );
        if (correspondencia) return correspondencia;
        return Object.prototype.hasOwnProperty.call(ALIAS_DISTRITOS, atual)
          ? ALIAS_DISTRITOS[atual]
          : "Outro";
      },
      set(valor) {
        this.address.distrito = valor;
      },
    },
    textualAddress() {
      const {
        pais,
        morada,
        codigoPostal,
        freguesia,
        localidade,
        concelho,
        distrito,
      } = this.address;

      return [
        pais,
        morada,
        codigoPostal,
        freguesia,
        localidade,
        concelho,
        distrito,
      ]
        .filter((v) => v && v.trim() !== "")
        .join(", ");
    },
    hasCoordinates() {
      const { latitude, longitude } = this.address;
      return (
        latitude &&
        longitude &&
        !isNaN(parseFloat(latitude)) &&
        !isNaN(parseFloat(longitude))
      );
    },
  },
  methods: {
    //---------------------------------------------------------
    //  COMMON / SINGLE-PIN MODE METHODS
    //---------------------------------------------------------
    close() {
      this.$emit("close");
    },
    save_address() {
      console.log("address:", this.address);
      this.$emit("save", this.address);
    },
    async forwardGeocodeAddress() {
      if (!this.textualAddress) return null;
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          this.textualAddress
        )}&key=${this.api_key.toString()}`
      );
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        return data.results[0].geometry.location;
      }
      return null;
    },
    async reverseGeocode(lat, lng) {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${this.api_key.toString()}`
      );
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        return {
          location: data.results[0].geometry.location,
          components: data.results[0].address_components,
        };
      }
      return null;
    },
    parseAddressComponents(components) {
      const address = { id: this.initialAddress.id };
      let routeName = "";
      let streetNumber = "";
      let codigoPais = "";
      let areaNivel2 = "";
      let areaNivel3 = "";

      for (const component of components) {
        const types = component.types;
        if (types.includes("country")) {
          address.pais = component.long_name;
          codigoPais = component.short_name;
        }
        if (types.includes("postal_code"))
          address.codigoPostal = component.long_name;
        if (types.includes("locality") || types.includes("sublocality"))
          address.localidade = component.long_name;
        if (types.includes("administrative_area_level_1"))
          address.distrito = component.long_name;
        if (types.includes("administrative_area_level_2")) {
          address.freguesia = component.long_name;
          areaNivel2 = component.long_name;
        }
        if (types.includes("administrative_area_level_3")) {
          address.concelho = component.long_name;
          areaNivel3 = component.long_name;
        }

        if (types.includes("route")) {
          routeName = component.long_name;
        }
        if (types.includes("street_number")) {
          streetNumber = component.long_name;
        }
      }

      // Combine route and street number
      if (routeName) {
        address.morada = routeName;
        if (streetNumber) {
          address.morada += " " + streetNumber;
        }
      }

      // Açores/Madeira: substituir a região pela ilha do município
      const ilha = ilhaDaRegiaoAutonoma(address.pais, codigoPais, address.distrito, [
        areaNivel2,
        areaNivel3,
        address.localidade,
      ]);
      if (ilha) address.distrito = ilha;

      return address;
    },
    updateMarkerPosition(event) {
      const position = event.latLng.toJSON();
      this.address.latitude = position.lat;
      this.address.longitude = position.lng;
      this.applyCoordinates();
    },
    async set_pin_address() {
      if (this.hasCoordinates) {
        // We already have coordinates; reverse geocode them
        const lat = parseFloat(this.address.latitude);
        const lng = parseFloat(this.address.longitude);
        const result = await this.reverseGeocode(lat, lng);
        if (result) {
          const newData = this.parseAddressComponents(result.components);
          this.address = {
            ...this.address,
            ...newData,
          };
          this.applyCoordinates();
        }
      } else {
        // No coordinates: use the pin location (mapCenter)
        const lat = this.mapCenter.lat;
        const lng = this.mapCenter.lng;
        const result = await this.reverseGeocode(lat, lng);
        if (result) {
          const newData = this.parseAddressComponents(result.components);
          // Fill fields with pin location
          this.address = {
            ...this.address,
            ...newData,
            latitude: lat,
            longitude: lng,
          };
          this.applyCoordinates();
        } else {
          console.log("No reverse geocode results for pin location.");
        }
      }
    },
    async set_address() {
      const newCenter = await this.forwardGeocodeAddress();
      if (newCenter) {
        this.address.latitude = newCenter.lat;
        this.address.longitude = newCenter.lng;
        this.applyCoordinates();
      } else {
        console.log("No results found for the given address.");
      }
    },
    applyCoordinates() {
      if (this.hasCoordinates) {
        const lat = parseFloat(this.address.latitude);
        const lng = parseFloat(this.address.longitude);
        this.mapCenter = { lat, lng };
      }
    },

    find_my_location() {
      // Check if the browser supports Geolocation
      if (!navigator.geolocation) {
        toast.error("Geolocation is not supported by your browser.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          // Find the highlighted pin in local array
          const highlightedPin = this.multiplePin_coordinates.find(
            (pin) => pin.highlight
          );
          if (highlightedPin) {
            // Update pin's coordinates to the user's location
            highlightedPin.lat = lat;
            highlightedPin.lng = lng;
          } else {
            // If no highlighted pin, decide what to do.
            // For example, just log or handle gracefully:
            console.log("No highlighted pin found to update.");
          }

          // Center the map on the new location
          this.mapCenter = { lat, lng };
        },
        (error) => {
          console.log("Error getting location:", error);
          toast.error("Error getting IP-based location:" + error.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      );
    },

    async find_my_location_ip() {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();
        console.log("IP-based geolocation:", data);
        // data.latitude, data.longitude
        // data.city, data.region, data.country_name, etc.

        // If you have a "highlighted pin", for instance:
        const highlightedPin = this.multiplePin_coordinates.find(
          (pin) => pin.highlight
        );
        if (highlightedPin) {
          highlightedPin.lat = data.latitude;
          highlightedPin.lng = data.longitude;
        }

        // Center your map
        this.mapCenter = { lat: data.latitude, lng: data.longitude };
      } catch (err) {
        toast.error("Error getting IP-based location:", err, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }
    },

    isHighlighted() {
      return this.multiplePin_coordinates.some((pin) => pin.highlight);
    },

    //---------------------------------------------------------
    //  MULTIPLE-PIN MODE METHODS
    //---------------------------------------------------------
    updatePinCoords(event, index) {
      const { lat, lng } = event.latLng.toJSON();
      this.multiplePin_coordinates[index].lat = lat;
      this.multiplePin_coordinates[index].lng = lng;
    },
    save_multiPins() {
      // Emit the final multiplePin_coordinates
      this.$emit("save_multiPins", this.multiplePin_coordinates);
    },

    async fetchSchema() {
      try {
        const response = await axios.get(`${this.baseURL}/api/v1/schema/atual`);
        console.log("response:", response);
        if (response.data && response.data.schema) {
          this.currentSchema = response.data.schema;
        } else {
          this.currentSchema = "Schema não encontrado";
        }
      } catch (error) {
        console.error("Erro ao buscar schema atual:", error);
        this.currentSchema = "Erro ao carregar schema";
      }
    },

    async fetchEmpresaAPI() {
      try {
        // Ensure we have the current schema before proceeding
        if (!this.currentSchema) {
          await this.fetchSchema();
        }

        // Use axios instead of fetch to leverage the interceptors
        const response = await axios.get(
          `${this.baseURL}/api/v1/empresa/nome/`
        );

        // With axios, data is directly available in response.data
        if (response.data) {
          this.api_key = response.data.chave_api || "";
          console.log("API key loaded:", this.api_key);
        }
      } catch (error) {
        console.error("Erro ao buscar dados da empresa:", error);
        toast.error("Erro ao carregar dados da empresa", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    },
  },
  async created() {},
  async beforeMount() {
    await this.fetchSchema();
    await this.fetchEmpresaAPI(); // define api_key uma única vez
    console.log("currentSchema:", this.currentSchema);
  },
  async mounted() {
    // If single-pin mode has coordinates, apply them
    if (this.hasCoordinates) {
      this.applyCoordinates();
    }

    // Initialize local array from the prop multiplePin_data
    this.multiplePin_coordinates = this.multiplePin_data.map((item) => ({
      id: item.id,
      lat: parseFloat(item.latitude),
      lng: parseFloat(item.longitude),
      highlight: item.highlight,
    }));

   

    // If multiplePin_mode is true and we have at least one coordinate,
    // center the map on the first pin.
    if (this.multiplePin_mode && this.multiplePin_coordinates.length > 0) {
      this.mapCenter = {
        lat: this.multiplePin_coordinates[0].lat,
        lng: this.multiplePin_coordinates[0].lng,
      };
    }
  },
  watch: {
    multiplePin_data: {
      handler(newVal) {
        newVal.forEach((updatedItem) => {
          const localIndex = this.multiplePin_coordinates.findIndex(
            (localPin) => localPin.id === updatedItem.id
          );
          if (localIndex !== -1) {
            const localPin = this.multiplePin_coordinates[localIndex];

            // MERGE highlight
            localPin.highlight = updatedItem.highlight;

            // Example: only overwrite lat/lng if parent's version is newer
            // if (updatedItem.lastUpdated > localPin.lastUpdated) {
            //   localPin.lat = parseFloat(updatedItem.latitude);
            //   localPin.lng = parseFloat(updatedItem.longitude);
            //   localPin.lastUpdated = updatedItem.lastUpdated;
            // }
          } else {
            // This pin didn't exist locally, so add it
            this.multiplePin_coordinates.push({
              id: updatedItem.id,
              lat: parseFloat(updatedItem.latitude),
              lng: parseFloat(updatedItem.longitude),
              highlight: updatedItem.highlight,
              // lastUpdated: updatedItem.lastUpdated,
            });
          }
        });

        // If you still want to auto-center on the first pin
        if (this.multiplePin_mode && this.multiplePin_coordinates.length > 0) {
          this.mapCenter = {
            lat: this.multiplePin_coordinates[0].lat,
            lng: this.multiplePin_coordinates[0].lng,
          };
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.text-black {
  color: var(--text);
}
</style>
